import styled from '@emotion/styled';
import { styled as zds } from '@zoopla-eng/zds-components/themes';
import { css } from '@emotion/react';

export const HeadingRow = zds('div', {
    marginBottom: '$S500',
    display: 'flex',
    alignItems: 'center',
    a: {
        marginLeft: 'auto'
    }
});

export const StyledListingCardScrollRow = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        flex-wrap: nowrap;
        align-items: stretch; /* force cards to all take height of tallest */
        width: 100%;

        > .trigger-when-visible {
            margin: ${spacing['4px']} ${spacing['8px']};
            &:nth-of-type(1) {
                margin-left: ${spacing[
                    '4px'
                ]}; // just enough to show focus ring
            }

            &:last-of-type {
                margin-right: ${spacing[
                    '4px'
                ]}; // just enough to show focus ring
            }
            height: auto; /* allow their height to be set by the flex rules of container */
            flex-basis: 17.5rem;
            flex-grow: 0;
            flex-shrink: 0;
        }
    `
);
